import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData, sanitizePageDataSearch } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ConfiguratorPageInitialData } from "./configuratorPageInitialData";

export const configuratorPageQueryOptions = (productCode: string, search = "") => {
  const sanitizedSearch = sanitizePageDataSearch(search);
  const encodedProductCode = encodeURIComponent(productCode);
  return queryOptions({
    queryKey: pageDataKeys.configurator(productCode, sanitizedSearch),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<ConfiguratorPageInitialData>>(
        `/page-data/configurator/${encodedProductCode}${sanitizedSearch}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
